import Routes from 'routes';

import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import ThemeCustomization from 'themes';

import { CustomCognitoProvider as AuthProvider } from 'contexts/CustomCognitoContext';
import QueueSnackBar from 'ui-component/extended/queueSnackBarComponent';
import UserTicketFloatingButton from 'views/userTicketSection';
import { Box } from '@mui/material';
import useStyles from './styles';

// ==============================|| APP ||============================== //

const App = () => {
    const classes = useStyles();

    return (
        <>
            <ThemeCustomization>
                <RTLLayout>
                    <Locales>
                        <NavigationScroll>
                            <AuthProvider>
                                <Routes />
                                <Snackbar />
                                <QueueSnackBar />
                                <Box className={classes.userTicketSection}>
                                    <UserTicketFloatingButton />
                                </Box>
                            </AuthProvider>
                        </NavigationScroll>
                    </Locales>
                </RTLLayout>
            </ThemeCustomization>
        </>
    );
};

export default App;
